import { ZodType, z } from 'zod';

export type Session = {
	id: number;
	login: string;
	balance: number;
	active: boolean;
	createdAt: string;
	roleId: number;
	statusId?: string | null;
	currencyId: number;
	isPaymentSystemUser: boolean;
	role: string;
	permission: Record<string, boolean | null>;
	currency: string;
};

export const sessionSchema: ZodType<Session> = z.object({
	id: z.number(),
	login: z.string(),
	balance: z.number(),
	active: z.boolean(),
	createdAt: z.string(),
	roleId: z.number(),
	statusId: z.string().optional().nullable(),
	currencyId: z.number(),
	isPaymentSystemUser: z.boolean(),
	role: z.string(),
	permission: z.record(z.boolean().nullable()),
	currency: z.string(),
});
